import { useState, useEffect, useRef, useCallback } from "react";
import { io } from "socket.io-client";
import { GOLD, BLUE } from "../constants/temas";

const API = process.env.REACT_APP_API_URL || "https://adorateam-api-532602191494.us-central1.run.app";
const EMOJIS_RAPIDOS = ["👍", "❤️", "🔥", "🙏", "😂", "😮"];

function getToken() { return localStorage.getItem("adorateam_token"); }

async function uploadArquivoChat(file) {
    const form = new FormData();
    form.append("arquivo", file);
    const res = await fetch(`${API}/api/chat/upload`, {
        method: "POST",
        headers: { Authorization: `Bearer ${getToken()}` },
        body: form,
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.erro || "Falha no upload");
    }
    return await res.json();
}

function Avatar({ nome, foto, size = 32 }) {
    if (foto) {
        return <img src={foto} alt={nome} style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", flexShrink: 0, border: `2px solid ${GOLD}44` }} />;
    }
    return (
        <div style={{ width: size, height: size, borderRadius: "50%", flexShrink: 0, background: `linear-gradient(135deg, ${GOLD}44, ${GOLD}22)`, border: `2px solid ${GOLD}44`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.4, fontWeight: 700, color: GOLD }}>
            {(nome || "?")[0].toUpperCase()}
        </div>
    );
}

const VELOCIDADES = [1, 1.25, 1.5, 2];

function PlayerAudio({ src, minha, T }) {
    const [tocando, setTocando] = useState(false);
    const [progresso, setProgresso] = useState(0);
    const [duracao, setDuracao] = useState(0);
    // NOVO: controle de velocidade
    const [velIdx, setVelIdx] = useState(0);
    const audioRef = useRef(null);

    const toggle = () => {
        const a = audioRef.current;
        if (!a) return;
        if (tocando) { a.pause(); setTocando(false); }
        else { a.play(); setTocando(true); }
    };

    // Alterna velocidade e aplica imediatamente
    const alternarVelocidade = () => {
        const novoIdx = (velIdx + 1) % VELOCIDADES.length;
        setVelIdx(novoIdx);
        if (audioRef.current) audioRef.current.playbackRate = VELOCIDADES[novoIdx];
    };

    const fmt = (s) => (!s || isNaN(s)) ? "0:00" : `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`;
    const pct = duracao ? (progresso / duracao) * 100 : 0;
    const corBotao = minha ? "rgba(0,0,0,0.25)" : GOLD;
    const corBarra = minha ? "rgba(255,255,255,0.5)" : GOLD;
    const corBarraBg = minha ? "rgba(0,0,0,0.15)" : T.borda;
    const velAtual = VELOCIDADES[velIdx];

    return (
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", minWidth: 210 }}>
            <audio ref={audioRef} src={src} onTimeUpdate={e => setProgresso(e.target.currentTime)} onLoadedMetadata={e => setDuracao(e.target.duration)} onEnded={() => { setTocando(false); setProgresso(0); }} />
            <button onClick={toggle} style={{ width: 40, height: 40, borderRadius: "50%", flexShrink: 0, background: corBotao, border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.2)" }}>
                {tocando
                    ? <svg width="14" height="14" viewBox="0 0 24 24" fill={minha ? "white" : BLUE}><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
                    : <svg width="14" height="14" viewBox="0 0 24 24" fill={minha ? "white" : BLUE}><path d="M8 5v14l11-7z"/></svg>}
            </button>
            <div style={{ flex: 1 }}>
                <div style={{ position: "relative", height: 28, display: "flex", alignItems: "center", cursor: "pointer", marginBottom: 2 }}
                     onClick={e => { const rect = e.currentTarget.getBoundingClientRect(); if (audioRef.current) audioRef.current.currentTime = ((e.clientX - rect.left) / rect.width) * duracao; }}>
                    {Array.from({ length: 28 }, (_, i) => {
                        const alturas = [3,5,8,12,10,14,10,8,12,16,10,8,12,10,14,8,10,12,8,10,14,10,8,12,8,10,6,4];
                        const ativo = (i / 28 * 100) < pct;
                        return <div key={i} style={{ width: 3, marginRight: 1, borderRadius: 2, height: alturas[i] || 8, background: ativo ? corBarra : corBarraBg, transition: "background 0.1s", flexShrink: 0 }} />;
                    })}
                </div>
                <div style={{ fontSize: 10, color: minha ? "rgba(255,255,255,0.7)" : T.textoSecundario }}>{fmt(tocando ? progresso : duracao)}</div>
            </div>
            {/* NOVO: botão de velocidade */}
            <button onClick={alternarVelocidade} style={{
                background: minha ? "rgba(0,0,0,0.18)" : T.bgCardSecundario || "#ffffff12",
                border: "none", borderRadius: 8, padding: "3px 7px",
                cursor: "pointer", flexShrink: 0,
                fontSize: 11, fontWeight: 800,
                color: minha ? "rgba(0,0,0,0.7)" : GOLD,
                minWidth: 36, textAlign: "center",
            }}>
                {velAtual === 1 ? "1x" : `${velAtual}x`}
            </button>
        </div>
    );
}

function BalaoPDF({ src, nome, minha, T }) {
    return (
        <a href={src} target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", textDecoration: "none", minWidth: 200 }}>
            <div style={{ width: 44, height: 44, borderRadius: 12, flexShrink: 0, background: minha ? "rgba(255,255,255,0.2)" : "#ff525218", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill={minha ? "white" : "#f44336"}>
                    <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7H20.5v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"/>
                </svg>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: minha ? "rgba(0,0,0,0.8)" : T.texto, marginBottom: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{nome || "Documento PDF"}</div>
                <div style={{ fontSize: 11, color: minha ? "rgba(0,0,0,0.5)" : T.textoSecundario }}>Toque para abrir</div>
            </div>
        </a>
    );
}

function BaloVideo({ src }) {
    const [fullscreen, setFullscreen] = useState(false);
    const videoRef = useRef(null);
    return (
        <>
            <div style={{ position: "relative", borderRadius: 14, overflow: "hidden", maxWidth: 240, cursor: "pointer" }} onClick={() => setFullscreen(true)}>
                <video ref={videoRef} src={src} style={{ width: "100%", display: "block" }} playsInline muted />
                <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.35)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div style={{ width: 48, height: 48, borderRadius: "50%", background: GOLD, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: `0 4px 16px ${GOLD}55` }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill={BLUE}><path d="M8 5v14l11-7z"/></svg>
                    </div>
                </div>
            </div>
            {fullscreen && (
                <div onClick={() => setFullscreen(false)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.95)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <video src={src} controls autoPlay style={{ maxWidth: "100%", maxHeight: "90vh", borderRadius: 12 }} playsInline onClick={e => e.stopPropagation()} />
                    <button onClick={() => setFullscreen(false)} style={{ position: "absolute", top: 20, right: 20, background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "50%", width: 40, height: 40, color: "white", fontSize: 20, cursor: "pointer" }}>✕</button>
                </div>
            )}
        </>
    );
}

export default function Chat({ usuario, tema: T }) {
    const [mensagens, setMensagens] = useState([]);
    const [texto, setTexto] = useState("");
    const [digitandoInfo, setDigitandoInfo] = useState(null);
    const [online, setOnline] = useState([]);
    // CORREÇÃO 1: membros reais do grupo
    const [membros, setMembros] = useState([]);
    const [mencaoAberta, setMencaoAberta] = useState(false);
    const [mencaoBusca, setMencaoBusca] = useState("");
    const [mencoes, setMencoes] = useState([]);
    const [reacaoMsgId, setReacaoMsgId] = useState(null);
    const [carregando, setCarregando] = useState(true);
    const [gravando, setGravando] = useState(false);
    const [tempoGravacao, setTempoGravacao] = useState(0);
    const [enviandoMidia, setEnviandoMidia] = useState(false);
    const [menuAnexo, setMenuAnexo] = useState(false);

    const socketRef = useRef(null);
    const bottomRef = useRef(null);
    const inputRef = useRef(null);
    const digitandoTimeout = useRef(null);
    const fileImgRef = useRef(null);
    const filePdfRef = useRef(null);
    const fileVideoRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const chunksRef = useRef([]);
    const timerRef = useRef(null);

    // CORREÇÃO 1: busca membros reais da API — independente do socket
    useEffect(() => {
        fetch(`${API}/api/grupos/meu`, { headers: { Authorization: `Bearer ${getToken()}` } })
            .then(r => r.ok ? r.json() : null)
            .then(data => {
                if (!data) return;
                setMembros((data.membros || []).map(m => ({
                    id: m.id,
                    nome: m.nome,
                    foto: m.foto || m.foto_url || null,
                })));
            })
            .catch(() => {});
    }, []);

    useEffect(() => {
        const socket = io(API, { auth: { token: getToken() } });
        socketRef.current = socket;

        socket.on("nova_mensagem", (msg) => {
            setMensagens(prev => [...prev, msg]);
            setTimeout(() => bottomRef.current?.scrollIntoView({ behavior: "smooth" }), 50);
        });
        socket.on("reacao_atualizada", ({ mensagem_id, reacoes }) => {
            setMensagens(prev => prev.map(m => m.id === mensagem_id ? { ...m, reacoes } : m));
        });
        socket.on("online", (lista) => setOnline(lista));
        socket.on("digitando", ({ nome, digitando }) => {
            if (digitando) {
                setDigitandoInfo(nome);
                clearTimeout(digitandoTimeout.current);
                digitandoTimeout.current = setTimeout(() => setDigitandoInfo(null), 3000);
            } else setDigitandoInfo(null);
        });

        fetch(`${API}/api/chat/mensagens`, { headers: { Authorization: `Bearer ${getToken()}` } })
            .then(r => r.json())
            .then(data => {
                setMensagens(data.mensagens || []);
                setCarregando(false);
                setTimeout(() => bottomRef.current?.scrollIntoView(), 100);
            })
            .catch(() => setCarregando(false));

        return () => { socket.disconnect(); clearInterval(timerRef.current); };
    }, []);

    const enviarMensagem = useCallback(() => {
        if (!texto.trim()) return;
        socketRef.current?.emit("mensagem", { texto: texto.trim(), mencoes: mencoes.map(m => ({ id: m.id, nome: m.nome })) });
        setTexto(""); setMencoes([]);
        inputRef.current?.focus();
    }, [texto, mencoes]);

    const enviarArquivo = async (file, tipo) => {
        if (!file) return;
        setEnviandoMidia(true);
        setMenuAnexo(false);
        try {
            const { url, nome } = await uploadArquivoChat(file);
            socketRef.current?.emit("mensagem", { tipo, url, nome });
        } catch (e) {
            alert("Erro ao enviar arquivo: " + e.message);
        } finally {
            setEnviandoMidia(false);
        }
    };

    const iniciarGravacao = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const mr = new MediaRecorder(stream, { mimeType: "audio/webm" });
            mediaRecorderRef.current = mr;
            chunksRef.current = [];
            mr.ondataavailable = (e) => { if (e.data.size > 0) chunksRef.current.push(e.data); };
            mr.onstop = async () => {
                stream.getTracks().forEach(t => t.stop());
                const blob = new Blob(chunksRef.current, { type: "audio/webm" });
                const file = new File([blob], `audio_${Date.now()}.webm`, { type: "audio/webm" });
                await enviarArquivo(file, "audio");
                setTempoGravacao(0);
                clearInterval(timerRef.current);
            };
            mr.start();
            setGravando(true);
            setTempoGravacao(0);
            timerRef.current = setInterval(() => setTempoGravacao(t => t + 1), 1000);
        } catch {
            alert("Permita acesso ao microfone para gravar áudio.");
        }
    };

    const pararGravacao = () => { mediaRecorderRef.current?.stop(); setGravando(false); clearInterval(timerRef.current); };
    const cancelarGravacao = () => {
        if (mediaRecorderRef.current?.state !== "inactive") {
            mediaRecorderRef.current.ondataavailable = null;
            mediaRecorderRef.current.onstop = null;
            mediaRecorderRef.current.stop();
        }
        setGravando(false); setTempoGravacao(0); clearInterval(timerRef.current);
    };

    const fmtTempo = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

    const reagir = (mensagem_id, emoji) => {
        socketRef.current?.emit("reagir", { mensagem_id, emoji });
        setReacaoMsgId(null);
    };

    const handleTexto = (e) => {
        const val = e.target.value;
        setTexto(val);
        const atIndex = val.lastIndexOf("@");
        if (atIndex !== -1 && !val.slice(atIndex + 1).includes(" ")) {
            setMencaoBusca(val.slice(atIndex + 1));
            setMencaoAberta(true);
        } else setMencaoAberta(false);
        socketRef.current?.emit("digitando", true);
        clearTimeout(digitandoTimeout.current);
        digitandoTimeout.current = setTimeout(() => socketRef.current?.emit("digitando", false), 1500);
    };

    const selecionarMencao = (membro) => {
        const atIndex = texto.lastIndexOf("@");
        setTexto(texto.slice(0, atIndex) + `@${membro.nome} `);
        setMencoes(prev => [...prev, membro]);
        setMencaoAberta(false);
        inputRef.current?.focus();
    };

    const highlightMencoes = (t) => t
        ? t.replace(/@(\w[\w\s]*?)(?=\s|$)/g, m => `<span style="color:${GOLD};font-weight:700">${m}</span>`)
        : t;

    const isMinha = (msg) => msg.user_id === usuario?.id;
    const formatarHora = (dt) => dt ? new Date(dt).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : "";
    const onlineExcluindoEu = online.filter(u => u.id !== usuario?.id);

    // CORREÇÃO 1: usa membros reais para menções; fallback para online
    const fonteMembros = membros.length > 0 ? membros : onlineExcluindoEu;
    const membrosFiltrados = fonteMembros.filter(m => m.nome?.toLowerCase().includes(mencaoBusca.toLowerCase()));

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 120px)", position: "relative", background: T.bg }}>
            <style>{`
                @keyframes msgIn { from { opacity:0; transform:translateY(6px) } to { opacity:1; transform:translateY(0) } }
                @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.3} }
                @keyframes spin { to { transform:rotate(360deg) } }
            `}</style>

            {/* Header */}
            <div style={{ padding: "10px 16px", borderBottom: `1px solid ${T.borda}`, display: "flex", alignItems: "center", gap: 10, background: T.nav }}>
                <div style={{ width: 38, height: 38, borderRadius: "50%", background: `${GOLD}22`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>💬</div>
                <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: T.texto }}>Chat do Grupo</div>
                    {onlineExcluindoEu.length > 0 && (
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#4caf50" }} />
                            <span style={{ fontSize: 11, color: T.textoSecundario }}>{onlineExcluindoEu.length} online</span>
                        </div>
                    )}
                </div>
            </div>

            {/* Mensagens */}
            <div style={{ flex: 1, overflowY: "auto", padding: "12px 12px 8px" }}>
                {carregando && (
                    <div style={{ textAlign: "center", color: T.textoSecundario, marginTop: 40, fontSize: 14 }}>
                        <div style={{ width: 32, height: 32, border: `3px solid ${T.borda}`, borderTop: `3px solid ${GOLD}`, borderRadius: "50%", animation: "spin 1s linear infinite", margin: "0 auto 12px" }} />
                        Carregando mensagens...
                    </div>
                )}
                {!carregando && mensagens.length === 0 && (
                    <div style={{ textAlign: "center", marginTop: 60 }}>
                        <div style={{ fontSize: 48, marginBottom: 12 }}>💬</div>
                        <div style={{ fontSize: 15, fontWeight: 700, color: T.texto }}>Nenhuma mensagem ainda</div>
                        <div style={{ fontSize: 13, color: T.textoSecundario, marginTop: 4 }}>Seja o primeiro a enviar!</div>
                    </div>
                )}

                {mensagens.map((msg, idx) => {
                    const minha = isMinha(msg);
                    const anterior = mensagens[idx - 1];
                    const mesmoRemetente = anterior?.user_id === msg.user_id;
                    const mostrarAvatar = !minha && !mesmoRemetente;
                    const mostrarNome = !minha && !mesmoRemetente;
                    const temReacoes = msg.reacoes && Object.keys(msg.reacoes).length > 0;

                    // CORREÇÃO 2: fallback melhorado para tipo — detecta áudio pela URL
                    const tipo = msg.tipo
                        || (msg.imagem ? "imagem"
                            : (msg.url && (msg.url.includes("audio") || msg.url.match(/\.(webm|mp3|ogg|m4a|wav)(\?|$)/i)) ? "audio"
                                : "texto"));

                    return (
                        <div key={msg.id} style={{ display: "flex", flexDirection: minha ? "row-reverse" : "row", alignItems: "flex-end", gap: 8, marginBottom: mesmoRemetente ? 2 : 10, animation: "msgIn 0.2s ease" }}>
                            {!minha && (
                                <div style={{ width: 34, flexShrink: 0, alignSelf: "flex-end" }}>
                                    {mostrarAvatar ? <Avatar nome={msg.autor_nome} foto={msg.autor_foto} size={34} /> : <div style={{ width: 34 }} />}
                                </div>
                            )}

                            <div style={{ maxWidth: "75%", display: "flex", flexDirection: "column", alignItems: minha ? "flex-end" : "flex-start" }}>
                                {mostrarNome && <div style={{ fontSize: 11, fontWeight: 700, color: GOLD, marginBottom: 3, marginLeft: 4 }}>{msg.autor_nome}</div>}

                                <div style={{ position: "relative" }}>
                                    <div
                                        onClick={() => setReacaoMsgId(reacaoMsgId === msg.id ? null : msg.id)}
                                        style={{
                                            background: minha ? `linear-gradient(135deg, ${GOLD}, #FFD166)` : T.bgCard,
                                            borderRadius: minha ? (mesmoRemetente ? "18px 4px 4px 18px" : "18px 4px 18px 18px") : (mesmoRemetente ? "4px 18px 18px 4px" : "4px 18px 18px 18px"),
                                            border: minha ? "none" : `1px solid ${T.borda}`,
                                            overflow: "hidden", cursor: "pointer",
                                            boxShadow: minha ? `0 2px 12px ${GOLD}33` : "0 1px 4px rgba(0,0,0,0.08)",
                                            padding: (tipo === "imagem" || tipo === "video") ? 3 : 0,
                                        }}
                                    >
                                        {tipo === "texto" && (
                                            <div style={{ fontSize: 14, color: minha ? BLUE : T.texto, lineHeight: 1.5, wordBreak: "break-word", padding: "9px 13px" }}
                                                 dangerouslySetInnerHTML={{ __html: highlightMencoes(msg.texto) }} />
                                        )}
                                        {tipo === "imagem" && <img src={msg.imagem || msg.url} alt="img" style={{ maxWidth: 240, maxHeight: 320, borderRadius: 12, display: "block", objectFit: "cover" }} />}
                                        {/* CORREÇÃO 2: fallback msg.audio caso url esteja em campo diferente */}
                                        {tipo === "audio" && <PlayerAudio src={msg.url || msg.audio} minha={minha} T={T} />}
                                        {tipo === "pdf" && <BalaoPDF src={msg.url} nome={msg.nome} minha={minha} T={T} />}
                                        {tipo === "video" && <BaloVideo src={msg.url} />}
                                    </div>

                                    {reacaoMsgId === msg.id && (
                                        <div style={{ position: "absolute", bottom: "100%", [minha ? "right" : "left"]: 0, background: T.bgCard, border: `1px solid ${T.borda}`, borderRadius: 28, padding: "8px 12px", display: "flex", gap: 6, zIndex: 20, boxShadow: "0 8px 24px rgba(0,0,0,0.15)", marginBottom: 6 }}>
                                            {EMOJIS_RAPIDOS.map(e => (
                                                <button key={e} onClick={() => reagir(msg.id, e)} style={{ background: "none", border: "none", fontSize: 24, cursor: "pointer", padding: "2px 3px", borderRadius: 8, transition: "transform 0.1s" }}
                                                        onMouseOver={ev => ev.currentTarget.style.transform = "scale(1.3)"}
                                                        onMouseOut={ev => ev.currentTarget.style.transform = "scale(1)"}>{e}</button>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 3, flexDirection: minha ? "row-reverse" : "row" }}>
                                    <span style={{ fontSize: 10, color: T.textoSecundario }}>{formatarHora(msg.created_at)}</span>
                                    {temReacoes && (
                                        <div style={{ display: "flex", gap: 3 }}>
                                            {Object.entries(msg.reacoes).map(([emoji, total]) => (
                                                <button key={emoji} onClick={() => reagir(msg.id, emoji)} style={{ background: T.bgCard, border: `1px solid ${T.borda}`, borderRadius: 20, padding: "1px 7px", fontSize: 11, cursor: "pointer", color: T.texto, display: "flex", alignItems: "center", gap: 3 }}>
                                                    {emoji} <span style={{ fontSize: 10 }}>{total}</span>
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}

                {digitandoInfo && (
                    <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "4px 8px" }}>
                        <div style={{ display: "flex", gap: 3 }}>
                            {[0, 1, 2].map(i => <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", background: T.textoSecundario, animation: `pulse 1.2s ${i * 0.2}s infinite` }} />)}
                        </div>
                        <span style={{ fontSize: 11, color: T.textoSecundario, fontStyle: "italic" }}>{digitandoInfo} está digitando</span>
                    </div>
                )}
                <div ref={bottomRef} />
            </div>

            {/* Menção */}
            {mencaoAberta && membrosFiltrados.length > 0 && (
                <div style={{ position: "absolute", bottom: 70, left: 12, right: 12, background: T.bgCard, border: `1px solid ${T.borda}`, borderRadius: 14, overflow: "hidden", zIndex: 20, boxShadow: "0 -4px 20px rgba(0,0,0,0.15)" }}>
                    {membrosFiltrados.slice(0, 5).map(m => (
                        <button key={m.id} onClick={() => selecionarMencao(m)} style={{ width: "100%", padding: "10px 14px", border: "none", background: "none", cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", gap: 10, borderBottom: `1px solid ${T.borda}` }}>
                            <Avatar nome={m.nome} foto={m.foto} size={28} />
                            <span style={{ fontSize: 14, color: T.texto, fontWeight: 600 }}>{m.nome}</span>
                        </button>
                    ))}
                </div>
            )}

            {/* Menu anexo */}
            {menuAnexo && (
                <div style={{ position: "absolute", bottom: 68, left: 12, background: T.bgCard, border: `1px solid ${T.borda}`, borderRadius: 18, padding: "6px 0", zIndex: 20, boxShadow: "0 -4px 24px rgba(0,0,0,0.15)", minWidth: 200 }}>
                    {[
                        { icon: "📷", label: "Foto / Imagem", color: "#4caf50", action: () => fileImgRef.current?.click() },
                        { icon: "🎬", label: "Vídeo", color: "#2196f3", action: () => fileVideoRef.current?.click() },
                        { icon: "📄", label: "PDF / Documento", color: "#f44336", action: () => filePdfRef.current?.click() },
                    ].map(item => (
                        <button key={item.label} onClick={() => { item.action(); setMenuAnexo(false); }} style={{ width: "100%", padding: "13px 18px", border: "none", background: "none", cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", gap: 14, fontSize: 14, color: T.texto }}>
                            <div style={{ width: 40, height: 40, borderRadius: 12, background: item.color + "18", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>{item.icon}</div>
                            <span style={{ fontWeight: 600 }}>{item.label}</span>
                        </button>
                    ))}
                </div>
            )}

            <input ref={fileImgRef} type="file" accept="image/*" style={{ display: "none" }} onChange={e => { enviarArquivo(e.target.files[0], "imagem"); e.target.value = ""; }} />
            <input ref={filePdfRef} type="file" accept=".pdf,application/pdf" style={{ display: "none" }} onChange={e => { enviarArquivo(e.target.files[0], "pdf"); e.target.value = ""; }} />
            <input ref={fileVideoRef} type="file" accept="video/*" style={{ display: "none" }} onChange={e => { enviarArquivo(e.target.files[0], "video"); e.target.value = ""; }} />

            {/* Gravação */}
            {gravando && (
                <div style={{ padding: "10px 16px", borderTop: `1px solid ${T.borda}`, background: T.nav, display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#f44336", animation: "pulse 1s infinite", flexShrink: 0 }} />
                    <span style={{ fontSize: 14, fontWeight: 700, color: "#f44336", flex: 1 }}>Gravando {fmtTempo(tempoGravacao)}</span>
                    <button onClick={cancelarGravacao} style={{ background: T.bgCard, border: `1px solid ${T.borda}`, borderRadius: 10, padding: "6px 14px", cursor: "pointer", fontSize: 13, color: T.textoSecundario }}>Cancelar</button>
                    <button onClick={pararGravacao} style={{ background: GOLD, border: "none", borderRadius: 10, padding: "6px 18px", cursor: "pointer", fontSize: 13, fontWeight: 700, color: BLUE }}>Enviar</button>
                </div>
            )}

            {enviandoMidia && !gravando && (
                <div style={{ padding: "12px 16px", borderTop: `1px solid ${T.borda}`, background: T.nav, display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{ width: 18, height: 18, border: `2px solid ${GOLD}`, borderTopColor: "transparent", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />
                    <span style={{ fontSize: 13, color: T.textoSecundario }}>Enviando arquivo...</span>
                </div>
            )}

            {/* Input */}
            {!gravando && !enviandoMidia && (
                <div style={{ padding: "10px 12px", borderTop: `1px solid ${T.borda}`, display: "flex", alignItems: "flex-end", gap: 8, background: T.nav }}>
                    <button onClick={() => setMenuAnexo(p => !p)} style={{ width: 42, height: 42, borderRadius: "50%", flexShrink: 0, background: menuAnexo ? GOLD : T.bgCard, border: `1px solid ${menuAnexo ? GOLD : T.borda}`, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "all 0.2s" }}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill={menuAnexo ? BLUE : T.textoSecundario}>
                            <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/>
                        </svg>
                    </button>

                    <div style={{ flex: 1, position: "relative" }}>
                        <textarea ref={inputRef} value={texto} onChange={handleTexto}
                                  onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); enviarMensagem(); } }}
                                  placeholder="Mensagem... (@ para mencionar)" rows={1}
                                  style={{ width: "100%", padding: "11px 16px", borderRadius: 24, border: `1.5px solid ${T.borda}`, background: T.input, color: T.texto, fontSize: 14, resize: "none", boxSizing: "border-box", outline: "none", maxHeight: 100, overflowY: "auto", fontFamily: "inherit", lineHeight: 1.5 }} />
                    </div>

                    {texto.trim() ? (
                        <button onClick={enviarMensagem} style={{ width: 42, height: 42, borderRadius: "50%", flexShrink: 0, background: `linear-gradient(135deg, ${GOLD}, #FFD166)`, border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: `0 2px 12px ${GOLD}55` }}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill={BLUE}><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
                        </button>
                    ) : (
                        <button onMouseDown={iniciarGravacao} style={{ width: 42, height: 42, borderRadius: "50%", flexShrink: 0, background: T.bgCard, border: `1px solid ${T.borda}`, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill={T.textoSecundario}>
                                <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>
                            </svg>
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}